// API highLowPrice {lowFinalPrice, highFinalPrice} bhejta hai. Ye dono rate
// GST ke SAATH (inclusive) hote hain.
//
// Faisla (14-Sep-2026, owner): website par HAR rate GST ke SAATH dikhega —
// "₹118.00/kg incl. 18% GST". Ex-GST kahin nahi. Backend/quote ab bhi taxable
// (ex-GST) bhejta hai; dikhane se pehle inclGst() se gross karo.
//
// Backend abhi taxableValue/gstPercent nahi bhejta (ticket 1.3 pending), isliye
// GST yahin se hataya jaata hai — default 18%. Jis din API gstPercent bhejne
// lage, use chautha argument bana kar pass kar do.

export const DEFAULT_GST_PERCENT = 18;

const round2 = (n: number): number =>
  Math.round((n + Number.EPSILON) * 100) / 100;

/** GST-inclusive price me se GST hata kar taxable (net) rate */
export function exGst(
  inclusive: number | string | undefined | null,
  gstPercent?: number | string | null
): number {
  const v = Number(inclusive);
  if (!Number.isFinite(v)) return NaN;
  const g = Number(gstPercent);
  const pct = Number.isFinite(g) && g >= 0 ? g : DEFAULT_GST_PERCENT;
  return round2(v / (1 + pct / 100));
}

/** Ex-GST (taxable) rate → GST ke SAATH wala rate (2 decimal) */
export function inclGst(
  exclusive: number | string | undefined | null,
  gstPercent?: number | string | null
): number {
  const v = Number(exclusive);
  if (!Number.isFinite(v)) return NaN;
  const g = Number(gstPercent);
  const pct = Number.isFinite(g) && g >= 0 ? g : DEFAULT_GST_PERCENT;
  return round2(v * (1 + pct / 100));
}

/**
 * Listing / product page ka rate — GST ke SAATH (API ka highLowPrice pehle se
 * inclusive hai). low aur high alag hon to range dikhti hai.
 */
export function priceText(
  low: number | string | undefined | null,
  high: number | string | undefined | null,
  unit?: string | null,
  gstPercent?: number | string | null
): string {
  void gstPercent;
  const l = Number(low);
  const h = Number(high);
  if (!Number.isFinite(l) || !Number.isFinite(h)) return "Price Not Available !";
  const ls = l.toFixed(2);
  const hs = h.toFixed(2);
  const suffix = unit ? `/${unit}` : "";
  const body = ls === hs ? `₹${ls}${suffix}` : `₹${ls} - ₹${hs}${suffix}`;
  return `${body} incl. GST`;
}

/** Purana behaviour — GST ke SAATH wala price (abhi kahin use nahi ho raha) */
export function priceTextInclGst(
  low: number | string | undefined | null,
  high: number | string | undefined | null,
  unit?: string | null
): string {
  const l = Number(low).toFixed(2);
  const h = Number(high).toFixed(2);
  const suffix = unit ? `/${unit}` : "";
  return l === h ? `₹${l}${suffix}` : `₹${l} - ₹${h}${suffix}`;
}

export function isSinglePrice(
  low: number | string | undefined | null,
  high: number | string | undefined | null
): boolean {
  return Number(low).toFixed(2) === Number(high).toFixed(2);
}
